import React from 'react';

import { toTitle } from '../../base2/utils';

interface Person {
  firstName: string;
  middleName?: string;
  lastName: string;
}

interface FullNameDisplayProps {
  person: Person;
}

export function FullNameDisplay({ person }: FullNameDisplayProps) {
  const { firstName, middleName, lastName } = person;

  const fullName = [ firstName, middleName, lastName ].filter(Boolean).join(' ');

  return <span className="full-name-display">{toTitle(fullName)}</span>;
}
